import React, { useContext, useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import InsertPage from "./pages/insertPage/InsertPage";
import LoginPage from "./pages/loginPage/LoginPage";
import ResetPage from "./pages/resetPage/ResetPage";
import SearchPage from "./pages/searchPage/SearchPage";
import SpecsheetPage from "./pages/specsheetPage/SpecsheetPage";
import ForgotPasswordPage from "./pages/forgotPasswordPage/ForgotPasswordPage";
import PageNotFoundPage from "./pages/pageNotFoundPage/PageNotFoundPage";
import ManageUsersPage from "./pages/manageUsersPage/ManageUsersPage";
import { AuthContext } from "./context/AuthContext";
import HomePage from "./pages/homePage/HomePage";
import InitializeGoogleAnalytics from "./helpers/InitializeGoogleAnalytics";
import FormSettingsPage from "./pages/formSettingsPage/FormSettingsPage";

function App() {
  const [role, setRole] = useState("");
  const { user } = useContext(AuthContext);

  // Here we initialize google analytics tracking
  useEffect(() => {
    InitializeGoogleAnalytics();
  }, []);

  useEffect(() => {
    async function confirmUser() {
      setRole(user.role);
    }
    if (user !== null) {
      confirmUser();
    }
  }, [user]);

  return (
    <div>
      <Routes>
        <Route path="/" element={<HomePage />} />

        <Route path="/signingin" element={<LoginPage />} />

        <Route path="/forgottenpassword" element={<ForgotPasswordPage />} />

        <Route path="/password/reset/:resetToken" element={<ResetPage />} />

        <Route
          path="/insert"
          element={
            role === "admin" ? <InsertPage /> : <Navigate to="/search" />
          }
        />

        <Route
          path="/search"
          element={
            role === "admin" || role === "user" ? (
              <SearchPage role={role} />
            ) : (
              <Navigate to="/signingin" />
            )
          }
        />

        <Route
          path="/specsheet/:active/:id/:titleTemplate"
          element={<SpecsheetPage />}
        />

        <Route
          path="/users"
          element={
            role === "admin" ? (
              <ManageUsersPage />
            ) : (
              <Navigate to="/signingin" />
            )
          }
        />

        <Route
          path="/formsettings"
          element={
            role === "admin" ? (
              <FormSettingsPage />
            ) : (
              <Navigate to="/signingin" />
            )
          }
        />

        <Route path="*" element={<PageNotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
